import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import it from "./locales/it.json";
import en from "./locales/en.json";
import ja from "./locales/ja.json";

const SUPPORTED = ["it", "en", "ja"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      ja: { translation: ja },
    },
    fallbackLng: "it",
    supportedLngs: SUPPORTED,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lng",
      caches: ["localStorage"],
      lookupLocalStorage: "cc_lang",
    },
    returnObjects: true,
    react: { useSuspense: false },
  });

export const SUPPORTED_LANGS = SUPPORTED;
export default i18n;
